<template>
    <div class="content">
        <div class="tab-container">
            <div class="d-flex w-100 h-100 flex-column align-items-center justify-content-center">
                <!-- <button class="btn-secondary-sm">新增存證檔案</button> -->
                <h3>
                    <span v-if="finished">上鏈成功</span>
                    <span v-else>上鏈中...請勿離開此頁面！</span>
                </h3>
                <p class="m-4 text-center">
                    <span v-if="finished">點擊上方「上鏈紀錄」查看或下載上鏈證明，或可至「驗證證據」頁面中進行驗證查詢。</span>
                    <span v-else>本次體驗僅為應用範例，並非上鏈至正式司法聯盟鏈。</span>
                </p>
                <div class="d-flex">
                    <div class="d-flex flex-column align-items-center">
                        <img :src="leftImg" alt="" class="mb-3" width="50%" />
                        <p class="">司法機關</p>
                    </div>
                    <div class="mt-4 relative d-flex flex-column align-items-center justfy-content-space" style="width: 25vw;">
                        <p class="text-secondary">{{ finished ? 100 : progressNum }}%</p>
                        <b-progress :value="finished ? 100 : progressNum" class="w-100 mb-3 border-radius" variant="primary">
                            <b-progress-bar class="bg-gradient-yellow border-radius" :value="finished ? 100 : progressNum"></b-progress-bar>
                        </b-progress>
                        <div class="stopwatch bg-lightyellow d-flex align-items-center justify-content-center" style="display:none !important">
                            <img src="../assets/img/icon/stopwatch.png" alt="" width="24px" height="24px">
                            <span class="mx-2 text-green font-xxl">{{sec}}.<span class="font-sm">{{msec}}</span></span>
                            <span class="font-xl">秒</span>
                        </div>
                    </div>
                    <div class="d-flex flex-column align-items-center">
                        <img :src="rightImg" alt="" class="mb-3" width="50%" />
                        <p class="">司法聯盟鏈</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="footer">
            <template v-if="finished">
                <!-- <button class="btn-primary-sm mx-3" @click="routerPush('/record')">第二步：查看上鏈結果</button> -->
                <button class="btn-secondary-blue mx-3" @click="reload()">繼續存證檔案</button>
                <button class="btn-primary-sm mx-3" @click="routerPush('/record')">查看上鏈結果</button>
            </template>
            <!-- <template v-else>
                <button class="btn-secondary-blue mx-3" @click="routerPush('/upload/file')">繼續存證檔案</button>
                <button class="btn-primary-sm mx-3" @click="routerPush('/record')">查看上鏈結果</button>
            </template> -->
        </div>
    </div>
</template>
<script>
import leftImg from "../assets/img/uploading_structure.png";
import rightImg from "../assets/img/uploading_logo.png";


export default {
    name: "UploadLoadingPage",
    props: {
        finished: Boolean,
        progressNum: Number,
        sec: Number,
        msec: Number,
    },
    methods: {
        routerPush(url) {
            this.$router.push(url);
        },
        reload() {
            this.$router.go();
        }
    },
    data() {
        return {
            file: null,
            leftImg: leftImg,
            rightImg: rightImg,
        };
    },
};
</script>